<citadel-form-section>
  <div class="header-strip mx-32 mt-32 mb-32">
    @if(this.otpType === 'SMS'){
      <div class="formHeader">Check your phone messaging app for an OTP (one-time-PIN) and enter it below.</div>
    }@else if(this.otpType === 'Email'){
      <div class="formHeader">Check your email for an OTP (one-time-PIN) and enter it below.</div>
    }@else{
      <div class="formHeader">Check your WhatsApp for an OTP (one-time-PIN) and enter it below.</div>
    }

    <div class="additional-security">This is required for additional security.</div>
  </div>
  <citadel-form-element class="mx-32">
    <citadel-otp-input (inputChange)="updateOtp($event)" (keyup)="handleKeyUp($event)" />
  </citadel-form-element>
  @if (showPinRequiredMsg) {
    <div class="invalid-feedback mx-32">
      <small>A 4-digit OTP is required</small>
    </div>
  }
  <div class="mx-32 mt-24 mb-32">
    <citadel-button [isSubmit]="true" buttonStyle="primary" (click)="signIn()" [heading]="isSigningIn ? 'Signing in...' : 'Sign in'" [disabled]="isSigningIn"
    [icon]="{right:'chevron-right'}" buttonSize="large" />
  </div>
  <div class="mx-32 mb-32">
    <a (click)="resendOTP()" class="no-otp">{{resendOtpText}}</a>
  </div>
</citadel-form-section>
